var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
  'banner',
  ("banner-" + _vm.variant)
]},[(_vm.hasIcon)?_c('m-icon',{attrs:{"size":"small","variant":_vm.iconVariant}}):_vm._e(),_vm._t("default",[_c('div',{staticClass:"banner-text"},[_c('div',[_vm._v(_vm._s(_vm.text))])]),_c('div',{staticClass:"banner-link"},[_c('a',{attrs:{"href":_vm.linkHref ? _vm.linkHref : null,"target":_vm.openLinkNewTab ? '_blank' : null}},[_vm._v(" "+_vm._s(_vm.linkText)+" ")])])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }